import { Volume2, VolumeX } from "lucide-react";
import { useSoundOn } from "../sound";

export default function SoundControls({ testId }) {
    const [on, toggle] = useSoundOn();
    return (
        <button
            onClick={toggle}
            data-testid={testId}
            aria-label="Suara hasil"
            className="flex h-8 w-8 items-center justify-center rounded-full border border-white/15 text-zinc-400 transition-colors duration-200 hover:border-white/40 hover:text-white"
        >
            {on ? <Volume2 size={14} /> : <VolumeX size={14} />}
        </button>
    );
}
